var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a, _b, _c, _d;
import { useState, useEffect } from "react";
import { validators, isFaultType } from "../../../../../utils";
import { FaultCategory, ResilienceFaults } from "../../../../../graphql";
import { CATEGORY_FAULTS_MAPPING, supportedAWSResourcesForBlackhole, targetServiceDropDownFieldFaults, targetServiceTextFieldFaults, percentageFieldFaults, stressorsFieldFaults, timeoutFieldFaults, delayFieldFaults, containerFieldFaults, blastRadiusFieldFaults, microsGroupsFieldFaults, targetDnsFieldFaults, resourceNameFieldFaults, removeAZFieldFaults, targetAZFieldFaults, rdsNameFieldFaults, methodFieldFaults, urlFieldFaults, statusFieldFaults, bodyFieldFaults, sourcesFieldFaults, wiremockArgumentsFieldFaults, targetRegionDropDownFieldFaults, supportedAWSRegionsForBlackhole } from "../../../../../models";
import { useAzFailoverResource, useAzComputeList } from "../useAzFailover";
import { useRdsListForAService } from "../useRdsListForAService";
import { useFaultCategories } from "../useFaultCategories";
import { useAnalytics } from "../../../../../analytics";
import { getDelayBeforeExecution } from "../getDelayBeforeExecution";
export var useFault = function (initialFault, containersForService, microsGroupsForService, serviceId, environment, faultBeingEditedIndex) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var _y = __read(useState(initialFault), 2), fault = _y[0], setFault = _y[1];
    useEffect(function () {
        setFault(initialFault);
    }, [initialFault]);
    function onChangeFaultParameter(key) {
        return function (value) {
            setFault(function (prevFault) {
                var _a;
                return (__assign(__assign({}, prevFault), { parameters: __assign(__assign({}, prevFault.parameters), (_a = {}, _a[key] = value, _a)) }));
            });
        };
    }
    var _z = useAzFailoverResource(fault.faultExecution, serviceId, environment), azFailoverResourceOptions = _z.options, isAzFailoverResourceOptionsLoading = _z.isLoading, azFailoverResourceDefaultOption = _z.defaultOption;
    useEffect(function () {
        onChangeFaultParameter("resource_name")(azFailoverResourceDefaultOption);
    }, [azFailoverResourceDefaultOption]);
    var _0 = useAzComputeList(fault.faultExecution, serviceId, environment), azFailoverComputeOptions = _0.options, isAzFailoverComputeOptionsLoading = _0.isLoading, azFailoverComputeDefaultOption = _0.defaultOption;
    useEffect(function () {
        if (fault.faultExecution &&
            fault.faultExecution === ResilienceFaults.compute_az_failover) {
            onChangeFaultParameter("remove_az")(azFailoverComputeDefaultOption);
        }
    }, [azFailoverComputeDefaultOption, fault.faultExecution]);
    var _1 = useRdsListForAService(fault.faultExecution, serviceId, environment), rdsNameOptions = _1.options, isRdsNameOptionsLoading = _1.isLoading, rdsNameDefaultOption = _1.defaultOption;
    useEffect(function () {
        onChangeFaultParameter("rds_name")(rdsNameDefaultOption);
    }, [rdsNameDefaultOption]);
    var setFaultExecution = function (faultExecution) {
        setFault(function (prevFault) {
            var isVisible = getIsVisible(prevFault.faultCategory, faultExecution);
            var getDefault = function (parameter) {
                var _a;
                var _b, _c, _d;
                if (!isVisible[parameter]) {
                    return {};
                }
                var defaultValue = (_c = (_b = DEFAULTS[parameter]) === null || _b === void 0 ? void 0 : _b[faultExecution]) !== null && _c !== void 0 ? _c : (_d = DEFAULTS[parameter]) === null || _d === void 0 ? void 0 : _d.other;
                if (defaultValue === undefined) {
                    return {};
                }
                return _a = {}, _a[parameter] = defaultValue, _a;
            };
            var _a = getDelayBeforeExecution(faultExecution, faultBeingEditedIndex), isDelayBeforeExecutionEnabled = _a.isDelayBeforeExecutionEnabled, delayBeforeExecutionDefaultValue = _a.delayBeforeExecutionDefaultValue;
            var parameters = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, getDefault("percentage")), getDefault("stressors")), getDefault("timeout_seconds")), getDefault("delay")), getDefault("blast_radius")), getDefault("resource_name")), getDefault("status")), (isVisible.container && {
                container: getContainerOptions(containersForService)[0]
            })), (isVisible.resource_name && {
                resource_name: azFailoverResourceDefaultOption
            })), (isVisible.remove_az && {
                remove_az: azFailoverComputeDefaultOption
            })), (isVisible.rds_name && {
                rds_name: rdsNameDefaultOption
            }));
            return __assign({ faultCategory: prevFault.faultCategory, faultExecution: faultExecution,
                parameters: parameters }, (isDelayBeforeExecutionEnabled && {
                delayBeforeExecution: delayBeforeExecutionDefaultValue
            }));
        });
    };
    var sendUIEvent = useAnalytics().sendUIEvent;
    var setFaultCategory = function (faultCategory) {
        sendUIEvent({
            source: "createWargamePlanTaskGroupDefinitionStep",
            actionSubject: "dropdown",
            action: "selected",
            actionSubjectId: "faultCateogory",
            attributes: {
                faultCategory: faultCategory
            }
        });
        setFault({ faultCategory: faultCategory });
        var faultExecutionOptions = getFaultExecutionOptions(faultCategory);
        setFaultExecution(faultExecutionOptions[0]);
    };
    var isVisible = getIsVisible(fault.faultCategory, fault.faultExecution);
    var faultCategories = useFaultCategories();
    var fields = [
        {
            type: "text-select",
            name: "faultCategory",
            options: faultCategories,
            label: "Fault Category",
            isRequired: true,
            value: fault.faultCategory,
            onChange: setFaultCategory
        },
        {
            type: "text-select",
            name: "faultExecution",
            options: getFaultExecutionOptions(fault.faultCategory),
            label: "Fault",
            isRequired: true,
            suffixMessage: getFaultExecutionSuffixMessage(fault.faultCategory, fault.faultExecution),
            value: fault.faultExecution,
            onChange: function (faultExecution) {
                sendUIEvent({
                    source: "createWargamePlanTaskGroupDefinitionStep",
                    actionSubject: "dropdown",
                    action: "selected",
                    actionSubjectId: "fault",
                    attributes: {
                        faultExecution: faultExecution
                    }
                });
                setFaultExecution(faultExecution);
            }
        }
    ];
    if (isVisible.target_service.dropdown) {
        fields.push({
            type: "text-select",
            name: "parameters.target_service",
            options: supportedAWSResourcesForBlackhole,
            label: "Target Service",
            labelHelperText: "Target aws resource to block",
            isRequired: true,
            value: (_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.target_service,
            onChange: onChangeFaultParameter("target_service")
        });
    }
    if (isVisible.target_region.dropdown) {
        fields.push({
            type: "text-select",
            name: "parameters.target_region",
            options: supportedAWSRegionsForBlackhole,
            label: "Target Region",
            labelHelperText: "Target aws region to block, If not specified, everything will be blocked",
            isRequired: false,
            value: (_b = fault.parameters) === null || _b === void 0 ? void 0 : _b.target_region,
            onChange: onChangeFaultParameter("target_region")
        });
    }
    if (isVisible.target_service.textField) {
        fields.push({
            type: "text",
            name: "parameters.target_service",
            label: "Target Service (comma separated)",
            labelHelperText: "The hostname(s) of the target service(s) to block (in comma separated format)",
            isRequired: true,
            placeholder: "chaos-engine.ap-southeast-2.dev.atl-paas.net, resilience-core.ap-southeast-2.dev.atl-paas.net",
            value: (_c = fault.parameters) === null || _c === void 0 ? void 0 : _c.target_service,
            onChange: onChangeFaultParameter("target_service")
        });
    }
    if (isVisible.percentage) {
        fields.push({
            type: "number",
            name: "parameters.percentage",
            label: "Percentage",
            isRequired: true,
            value: (_d = fault.parameters) === null || _d === void 0 ? void 0 : _d.percentage,
            onChange: onChangeFaultParameter("percentage"),
            validate: function () { var _a; return validators.between((_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.percentage, 1, 100); }
        });
    }
    if (isVisible.stressors) {
        fields.push({
            type: "number",
            name: "parameters.stressors",
            label: "Stressors",
            isRequired: true,
            value: (_e = fault.parameters) === null || _e === void 0 ? void 0 : _e.stressors,
            onChange: onChangeFaultParameter("stressors"),
            validate: function () { var _a; return validators.min((_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.stressors, 1); }
        });
    }
    if (isVisible.timeout_seconds) {
        fields.push({
            type: "number",
            name: "parameters.timeout_seconds",
            label: "Fault Duration (in Seconds)",
            labelHelperText: isFaultType(fault, ResilienceFaults.az_failure)
                ? "The fault injection duration. Duration should be in between 60 to 600 seconds"
                : "The fault injection duration. Max duration is 7000 seconds",
            isRequired: true,
            value: (_f = fault.parameters) === null || _f === void 0 ? void 0 : _f.timeout_seconds,
            onChange: onChangeFaultParameter("timeout_seconds"),
            validate: function () {
                var _a;
                return validators.between((_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.timeout_seconds, isFaultType(fault, ResilienceFaults.az_failure) ? 60 : 0, isFaultType(fault, ResilienceFaults.az_failure) ? 600 : 7000);
            }
        });
    }
    if (isVisible.delay) {
        var label = fault.faultExecution === ResilienceFaults.fixed_delay
            ? "API Endpoint Delay(Milli Seconds)"
            : "Delay (Milli Seconds)";
        var labelHelperText = fault.faultExecution === ResilienceFaults.fixed_delay
            ? ""
            : fault.faultExecution === ResilienceFaults.network_delay
                ? "The added network delay( in milliseconds) to all packets going out of the docker0 bridge interface."
                : "The added network delay( in milliseconds) to all packets directed to a selected target passing through the eth0 interface of the EC2 instance.";
        fields.push({
            type: "number",
            name: "parameters.delay",
            label: label,
            labelHelperText: labelHelperText,
            isRequired: true,
            value: (_g = fault.parameters) === null || _g === void 0 ? void 0 : _g.delay,
            onChange: onChangeFaultParameter("delay"),
            validate: function () { var _a; return validators.min((_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.delay, 1); }
        });
    }
    if (isVisible.sources) {
        fields.push({
            type: "text",
            name: "parameters.sources",
            label: "Source",
            labelHelperText: "IP address, CIDR block, or DNS of the target on which you wish to introduce the delay",
            isRequired: true,
            placeholder: "reqres.in",
            value: (_h = fault.parameters) === null || _h === void 0 ? void 0 : _h.sources,
            onChange: onChangeFaultParameter("sources")
        });
    }
    if (isVisible.container) {
        fields.push({
            type: "text-select",
            name: "parameters.container",
            options: getContainerOptions(containersForService),
            label: "Container",
            labelHelperText: "The name of the docker container where you want to inject faults. By default it is set to your application container.",
            value: (_j = fault.parameters) === null || _j === void 0 ? void 0 : _j.container,
            onChange: onChangeFaultParameter("container")
        });
    }
    if (isVisible.blast_radius) {
        fields.push({
            type: "number",
            name: "parameters.blast_radius",
            label: "Blast Radius (1% - 100%)",
            labelHelperText: "Limit the effect of fault injection to a certain percentage of instances",
            isRequired: true,
            value: (_k = fault.parameters) === null || _k === void 0 ? void 0 : _k.blast_radius,
            onChange: onChangeFaultParameter("blast_radius"),
            validate: function () { var _a; return validators.between((_a = fault.parameters) === null || _a === void 0 ? void 0 : _a.blast_radius, 1, 100); }
        });
    }
    if (isVisible.micros_groups) {
        fields.push({
            type: "text-select",
            name: "parameters.micros_groups",
            options: microsGroupsForService !== null && microsGroupsForService !== void 0 ? microsGroupsForService : [],
            label: "Micros Groups",
            labelHelperText: "The name of the micros worker group. By default, it is set to WebServer.",
            value: (_m = (_l = fault.parameters) === null || _l === void 0 ? void 0 : _l.micros_groups) === null || _m === void 0 ? void 0 : _m[0],
            onChange: function (value) { return onChangeFaultParameter("micros_groups")([value]); }
        });
    }
    if (isVisible.target_dns) {
        fields.push({
            type: "text",
            name: "parameters.target_dns",
            label: "Target (comma separated)",
            isRequired: true,
            labelHelperText: "The target service to be blackholed.",
            placeholder: "chaos-engine.ap-southeast-2.dev.atl-paas.net, resilience-core.ap-southeast-2.dev.atl-paas.net",
            value: (_o = fault.parameters) === null || _o === void 0 ? void 0 : _o.target_dns,
            onChange: onChangeFaultParameter("target_dns")
        });
    }
    if (isVisible.resource_name) {
        fields.push({
            type: "text-select",
            name: "parameters.resource_name",
            label: "Resource Name",
            labelHelperText: "The resource name for the services in the format (resource type : resource name)",
            isRequired: true,
            value: (_p = fault.parameters) === null || _p === void 0 ? void 0 : _p.resource_name,
            onChange: onChangeFaultParameter("resource_name"),
            options: azFailoverResourceOptions,
            isLoading: isAzFailoverResourceOptionsLoading
        });
    }
    if (isVisible.remove_az) {
        fields.push({
            type: "text-select",
            name: "parameters.remove_az",
            label: "Remove AZ",
            labelHelperText: "The Avaliablity Zones for the service",
            isRequired: true,
            value: (_q = fault.parameters) === null || _q === void 0 ? void 0 : _q.remove_az,
            onChange: onChangeFaultParameter("remove_az"),
            options: azFailoverComputeOptions,
            isLoading: isAzFailoverComputeOptionsLoading
        });
    }
    if (isVisible.rds_name) {
        fields.push({
            type: "text-select",
            name: "parameters.rds_name",
            label: "RDS Instance Name",
            labelHelperText: "Name of the RDS instance, defined in service descriptor",
            isRequired: true,
            value: (_r = fault.parameters) === null || _r === void 0 ? void 0 : _r.rds_name,
            onChange: onChangeFaultParameter("rds_name"),
            options: rdsNameOptions,
            isLoading: isRdsNameOptionsLoading
        });
    }
    if (isVisible.method) {
        fields.push({
            type: "text-select",
            name: "parameters.method",
            label: "Method",
            labelHelperText: "The HTTP Method",
            isRequired: true,
            value: (_s = fault.parameters) === null || _s === void 0 ? void 0 : _s.method,
            onChange: onChangeFaultParameter("method"),
            options: ["GET", "POST", "PUT", "DELETE"]
        });
    }
    if (isVisible.url) {
        fields.push({
            type: "text",
            name: "parameters.url",
            label: "API Path",
            isRequired: true,
            value: (_t = fault.parameters) === null || _t === void 0 ? void 0 : _t.url,
            onChange: onChangeFaultParameter("url"),
            placeholder: "/get/this"
        });
    }
    if (isVisible.status) {
        fields.push({
            type: "number",
            name: "parameters.status",
            label: "Status Code",
            labelHelperText: "The HTTP Status Code like 200, 401 etc.",
            isRequired: true,
            value: (_u = fault.parameters) === null || _u === void 0 ? void 0 : _u.status,
            onChange: onChangeFaultParameter("status")
        });
    }
    if (isVisible.body) {
        fields.push({
            type: "json",
            name: "parameters.body",
            label: "Body",
            isRequired: false,
            value: (_v = fault.parameters) === null || _v === void 0 ? void 0 : _v.body,
            onChange: onChangeFaultParameter("body"),
            placeholder: '{ "foo": "bar" }',
            minimumRows: 3
        });
    }
    if (isVisible.wiremock_args) {
        fields.push({
            type: "json",
            name: "parameters.wiremock_args",
            label: "Wiremock Arguments (Array of JSON objects)",
            isRequired: true,
            labelHelperText: "Multiple wiremock configurations for the fault",
            value: (_w = fault.parameters) === null || _w === void 0 ? void 0 : _w.wiremock_args,
            onChange: onChangeFaultParameter("wiremock_args"),
            placeholder: '[\n    {\n        "method": "GET",\n        "url": "/get/this",\n        "delay": 100,\n        "status": "201",\n        "body": ""\n},{\n        "method": "GET",\n        "url": "/get/that",\n        "status": "500",\n        "body": "{INTERNAL SERVER ERROR}"\n    }\n]',
            minimumRows: 3
        });
    }
    if (isVisible.target_az) {
        fields.push({
            type: "text-select",
            name: "parameters.target_az",
            label: "Target AZ",
            labelHelperText: "The Avaliablity Zone on which failure will be exceuted",
            isRequired: false,
            value: (_x = fault.parameters) === null || _x === void 0 ? void 0 : _x.target_az,
            onChange: onChangeFaultParameter("target_az"),
            options: azFailoverComputeOptions,
            isLoading: isAzFailoverComputeOptionsLoading
        });
    }
    var _2 = getDelayBeforeExecution(fault.faultExecution, faultBeingEditedIndex), isDelayBeforeExecutionEnabled = _2.isDelayBeforeExecutionEnabled, delayBeforeExecutionDefaultValue = _2.delayBeforeExecutionDefaultValue;
    if (isDelayBeforeExecutionEnabled) {
        fields.push({
            type: "number",
            name: "delayBeforeExecution",
            label: "Delay Before Execution(in seconds)",
            labelHelperText: "Delay before start of execution of this fault. Cannot be less than 30.",
            isRequired: true,
            value: fault.delayBeforeExecution,
            onChange: function (value) {
                setFault(function (prevFault) { return (__assign(__assign({}, prevFault), { delayBeforeExecution: value })); });
            },
            validate: function (value) {
                return validators.min(value, delayBeforeExecutionDefaultValue);
            }
        });
    }
    return {
        fault: fault,
        fields: fields
    };
};
var getFaultExecutionOptions = function (faultCategory) { var _a; return (_a = CATEGORY_FAULTS_MAPPING.get(faultCategory)) !== null && _a !== void 0 ? _a : []; };
var getContainerOptions = function (containersForService) {
    var _a, _b;
    var containerOptions = __spread(((_a = containersForService === null || containersForService === void 0 ? void 0 : containersForService.default) !== null && _a !== void 0 ? _a : []), ((_b = containersForService === null || containersForService === void 0 ? void 0 : containersForService["non-default"]) !== null && _b !== void 0 ? _b : []));
    return containerOptions;
};
var DEFAULTS = {
    percentage: {
        other: 50
    },
    stressors: {
        other: 5
    },
    timeout_seconds: (_a = {},
        _a[ResilienceFaults.dns_blackhole] = 1200,
        _a[ResilienceFaults.fixed_delay] = 300,
        _a[ResilienceFaults.custom_status_code] = 300,
        _a.other = 60,
        _a),
    delay: (_b = {},
        _b[ResilienceFaults.fixed_delay] = 100,
        _b.other = 600,
        _b),
    blast_radius: (_c = {},
        _c[ResilienceFaults.terminate_instances] = 0,
        _c.other = 100,
        _c),
    status: (_d = {},
        _d[ResilienceFaults.fixed_delay] = 200,
        _d)
};
var getIsVisible = function (faultCategory, faultExecution) { return ({
    target_service: {
        dropdown: targetServiceDropDownFieldFaults.includes(faultExecution),
        textField: targetServiceTextFieldFaults.includes(faultExecution)
    },
    target_region: {
        dropdown: targetRegionDropDownFieldFaults.includes(faultExecution)
    },
    percentage: percentageFieldFaults.includes(faultExecution),
    stressors: stressorsFieldFaults.includes(faultExecution),
    timeout_seconds: timeoutFieldFaults.includes(faultExecution),
    delay: delayFieldFaults.includes(faultExecution),
    sources: sourcesFieldFaults.includes(faultExecution),
    container: containerFieldFaults.includes(faultExecution),
    blast_radius: blastRadiusFieldFaults.includes(faultExecution),
    micros_groups: microsGroupsFieldFaults.includes(faultExecution),
    target_dns: targetDnsFieldFaults.includes(faultExecution),
    resource_name: resourceNameFieldFaults.includes(faultExecution),
    remove_az: removeAZFieldFaults.includes(faultExecution),
    target_az: targetAZFieldFaults.includes(faultExecution),
    rds_name: rdsNameFieldFaults.includes(faultExecution),
    method: methodFieldFaults.includes(faultExecution),
    url: urlFieldFaults.includes(faultExecution),
    status: statusFieldFaults.includes(faultExecution),
    body: bodyFieldFaults.includes(faultExecution),
    wiremock_args: wiremockArgumentsFieldFaults.includes(faultExecution)
}); };
var getFaultExecutionSuffixMessage = function (faultCategory, faultExecution) {
    if (faultCategory === FaultCategory.blackhole &&
        faultExecution &&
        faultExecution !== ResilienceFaults.dns_blackhole) {
        return "This blackhole is based on iptable";
    }
    if (faultCategory === FaultCategory.application_layer) {
        return "These faults are based on wiremock";
    }
    return undefined;
};
